import Modal from "antd/es/modal/Modal";
import MapLayersInMapTable from "../tables/MapLayersInMapTable";
import React from "react";

const MapLayersInMapModal = ({showModal, setShowModal, editMapConfig, setEditMapConfig, deleteLayers, setDeleteLayers,
                                 addLayers, setAddLayers, layers, setLayers}) => {

    const handleOk = () => {
        setShowModal(false);
    };
    const handleCancel = () => {
        setShowModal(false);
    };

    return (
        <>
            <Modal title="Layers Table" open={showModal} onOk={handleOk} onCancel={handleCancel} width={'60%'}>
                <MapLayersInMapTable editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig}
                                     addLayers={addLayers} setAddLayers={setAddLayers}
                                     deleteLayers={deleteLayers} setDeleteLayers={setDeleteLayers}
                                     layers={layers} setLayers={setLayers}/>
            </Modal>
        </>
    )
}
export default MapLayersInMapModal;